import { Outlet, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import FloatingButtons from '../components/FloatingButtons';

const UserLayout = ({ onLogout }) => {
  const navigate = useNavigate();
  
  const handleLogout = () => {
    // Clear all authentication-related data from localStorage
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('userRole');
    localStorage.removeItem('userEmail');
    localStorage.removeItem('lastLogin');
    localStorage.removeItem('token'); // Add this line to remove the token
    
    // Call the onLogout prop to update the auth state in App.jsx
    onLogout();
    
    // Navigate to login page
    navigate('/login');
  };

  return (
    <>
      <Helmet>
        <title>Panchali Boutique</title>
      </Helmet>
      <div className="min-h-screen flex flex-col">
        <Navbar onLogout={handleLogout} />
        <main className="flex-grow">
          <Outlet />
        </main>
        <Footer />
        <FloatingButtons />
      </div>
    </>
  );
};

export default UserLayout;






